import axios from "~/plugins/axios";

const selectSharedQuery = (context, sharedQuery) => {
  context.commit("SELECT_SHARED_QUERY", sharedQuery);
};

const deselectSharedQuery = (context, sharedQuery) => {
  context.commit("DESELECT_SHARED_QUERY", sharedQuery);
};

const changeAllSharedQueriesSelected = (context) => {
  context.commit("CHANGE_SHARED_QUERY_ALL_SELECTED");
};

const attachUserToSignals = ({ getters }, userId) => {
  const queryIds = getters.getSelectedSharedQueriesIds;
  axios.post("/web_api/v1/shared_signal_query/attach/", {
    user_id: userId,
    query_ids: queryIds,
  })
    .then((response) => {
      if (response.status === 200) {
        window.location.reload();
      }
    });
};

export default {
  selectSharedQuery,
  deselectSharedQuery,
  changeAllSharedQueriesSelected,
  attachUserToSignals,
};
